import { render, staticRenderFns } from "./almondco-intake-bin-list.vue?vue&type=template&id=017d7014&scoped=true"
import script from "./almondco-intake-bin-list.vue?vue&type=script&lang=js"
export * from "./almondco-intake-bin-list.vue?vue&type=script&lang=js"
import style0 from "./almondco-intake-bin-list.vue?vue&type=style&index=0&id=017d7014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d7014",
  null
  
)

export default component.exports